import { createClient } from "@supabase/supabase-js";

export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

const hasCredentials = !!supabaseUrl && !!supabaseKey;

if (!hasCredentials) {
  console.warn('⚠️ Supabase credentials tidak ditemukan — menggunakan mock client');
}

export const supabase = hasCredentials
  ? createClient(supabaseUrl, supabaseKey, {
      auth: { persistSession: true, autoRefreshToken: true },
      realtime: { params: { eventsPerSecond: 2 }, timeout: 30000 },
      global: { headers: { 'x-client-info': 'order-management-dashboard' } },
    })
  : (() => {
      const noop = () => Promise.resolve({ data: null, error: null });
      const authErr = () => Promise.resolve({ data: null, error: { message: 'Supabase not configured - missing env vars', status: 500 } });
      const chain = { select: () => chain, eq: () => chain, single: noop, order: () => chain, limit: () => chain, maybeSingle: noop, gte: () => chain, lte: () => chain, in: () => chain, not: () => chain, is: () => chain, textSearch: () => chain, contains: () => chain, filter: () => chain, or: () => chain, insert: () => chain, update: () => chain, delete: () => chain, upsert: () => chain, match: () => chain };
      return { from: () => chain, auth: { getUser: noop, getSession: noop, signOut: noop, onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }), signInWithPassword: authErr, signUp: authErr, signInWithOtp: authErr, refreshSession: authErr, setSession: authErr, updateUser: authErr, resetPasswordForEmail: authErr, verifyOtp: authErr, exchangeCodeForSession: authErr, admin: { listUsers: authErr } }, storage: { from: () => ({ upload: noop, getPublicUrl: () => ({ data: { publicUrl: '' } }) }) }, channel: () => ({ on: () => ({ subscribe: () => {} }), unsubscribe: () => {} }), removeChannel: () => {}, removeAllChannels: () => {} } as unknown as ReturnType<typeof createClient>;
    })();
